import React from 'react';
import { useNavigate } from 'react-router-dom';

import Button, { ButtonProps } from './Button';

export interface NavigationButtonProps extends ButtonProps {
  link?: string;
}

const NavigationButton = ({
  link,
  children,
  onClick,
  ...restProps
}: React.PropsWithChildren<NavigationButtonProps>) => {
  const navigate = useNavigate();

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    if (onClick) {
      await onClick(event);
    }

    if (link) {
      navigate(link);
    }
  };

  return (
    <Button {...restProps} onClick={handleClick}>
      {children}
    </Button>
  );
};

export default NavigationButton;
